import { useCallback } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useSelector } from 'src/redux/store';
import { Rule } from 'src/requests/roles.requests';

export function usePermission() {
  const { workspace } = useSelector((state) => state.workspace);
  const { user } = useAuthContext();

  const hasPermission = useCallback(
    (rule: Rule) => {
      if (rule === Rule.MOCK_DENIED) return false; // Enforce Denied Access

      if (workspace?.owner?.toString() === user?._id) return true; // Owner has all permissions

      if (user?.role.rules?.includes(Rule.ADMINISTRATOR)) return true; // Check if role has administrative rule

      if (user?.role.rules?.includes(rule)) return true; // Check the permission

      return false;
    },
    [workspace, user],
  );

  return {
    hasPermission,
  };
}
